import React from 'react';

function TermsPage() {
  return (
    <div className="page legal-page">
      <h2>Términos y Condiciones</h2>
      <p>
        El uso de QueComo implica la aceptación de estas condiciones generales. La plataforma brinda recomendaciones
        de menús e información orientativa para organización alimentaria.
      </p>
      <p>
        El usuario es responsable de validar ingredientes, alergias, porciones y condiciones particulares de salud,
        antes de consumir cualquier preparación sugerida.
      </p>
      <p>
        Los contenidos pueden actualizarse sin previo aviso para mejorar la experiencia y el funcionamiento del
        servicio.
      </p>
      <p>
        Ante dudas o consultas legales, podés contactarnos por los canales oficiales informados en el footer.
      </p>
    </div>
  );
}

export default TermsPage;
